import { MapTo } from "@adobe/aem-react-editable-components";
import { ReferAFriend } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const referAFriendItemEditConfig = {
    emptyLabel: "ReferAFriend",
    isEmpty: (props) => {
        if (props.variant === "raf") {
            return (!props.title ||
                !props.subtitle ||
                !props.registerUrl ||
                !props.registerTitle ||
                !props.signInUrl ||
                !props.signInTitle);
        }
        return !props.title || !props.subtitle;
    },
    getProps: (props) => ({
        variant: props.variant,
        header: props.header,
        title: props.title,
        subtitle: props.subtitle,
        subtitleDetails: props.subtitleDetails,
        registerUrl: props.registerUrl,
        registerTitle: props.registerTitle,
        signInUrl: props.signInUrl,
        signInTitle: props.signInTitle,
        stepslist: props.stepslist,
        stepslistloggedout: props.stepslistloggedout,
        isInEditor: props.isInEditor,
    }),
};
export default MapTo("loyalty/components/refer-a-friend")(withAemAuthoring(ReferAFriend, referAFriendItemEditConfig));
